var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-menu",class:{'open':_vm.menuOpen},on:{"click":_vm.onMenuClick}},[_c('transition',{attrs:{"mode":"out-in"}},[(_vm.menuOpen)?_c('div',{staticClass:"icon close"}):_c('HamburgerMenuIcon')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }